export default __webpack_public_path__ + "static/media/banana-busd.efc3947e.svg";